module.exports = __webpack_public_path__ + "img/wassalam.fdf8d5fa.jpeg";